import { useMutation } from 'react-query';
import { Guuid } from '../types/common';
import { PostConsentPayload } from '../types/postConsent';
import { postConsent } from '../utils/api';

export default () =>
  useMutation((data: { quoteId: Guuid; search: string; orgName: string; payload: PostConsentPayload }) =>
    postConsent(data.quoteId, data.search, data.orgName, data.payload)
  );
